import React, { forwardRef } from 'react'
import { usePaymentInputs } from 'react-payment-inputs'

import { TextInput, TextInputProps } from '../TextInput'

export interface CreditCardNumberInputProps extends TextInputProps {}

export const CreditCardNumberInput = forwardRef(
  ({ ...restProps }: CreditCardNumberInputProps, ref) => {
    const { getCardNumberProps } = usePaymentInputs()

    return (
      <TextInput
        {...getCardNumberProps()}
        placeholder="0000 0000 0000 0000"
        label="Card number"
        ref={ref}
        {...restProps}
      />
    )
  },
)

export default CreditCardNumberInput
